<template>
    <div class="detail-acticle-text">

        <div class="detail-acticle-text-title">
            <span v-html="text.title"></span>
            <div class="detail-acticle-text-title_line"></div>
        </div>
        <div class="detail-acticle-text-box">
            <p 
                class="detail-acticle-text_item" 
                v-for="v in text.section" 
                :key="v.id"
                v-html="v.text"
            >
            </p>
        </div>
    </div>
</template>
<script>

// import jquery from 'jquery'
    
export default {
    name: 'BaseList',
    props: {
        text: Object
    },
    data: function () {
      return {

      }
    },
    updated: function () {

    },
    mounted() {
        
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (min-width: 801px) {
    .detail-acticle-text {
       max-width: 1200px;
       margin: 0 auto;
    }

    .detail-acticle-text-title {
        max-width: 840px;
        position: relative;
        font-size: 38px;
        padding-bottom: 30px;
    }
    .detail-acticle-text-title_line {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #333;
        width:240px;
        height:2px;
    }
    .detail-acticle-text-box {
        padding-top: 50px;
        padding-left: 12%;
        padding-right: 12%;
        margin-bottom: 20px;
    }

    .detail-acticle-text_item {
        font-size: 20px;
        line-height: 1.5em;
        padding-bottom: 30px;
        color: #666;
    }
}

@media screen and (max-width: 800px) {
    .detail-acticle-text {
        width: 9.04rem;
        margin: 0 auto;
    }

    .detail-acticle-text-title {
        position: relative;
        font-size: .373rem;
        padding-bottom: .213rem;
        font-weight: bold;
    }

    .detail-acticle-text-title_line {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #333;
        width: 1.7rem;
        height: 2px;
    }

    .detail-acticle-text-box {
        padding-top: .533rem;
        padding-left: .69rem;
        padding-right: .69rem;        
        margin-bottom: .533rem;
    }

    .detail-acticle-text_item {
        font-size: .32rem;
        line-height: 1.5em;
        margin-bottom: .533rem;
        color: #666;
    }
}
</style>